import {
  IDisbursementFormData,
  isCheckDisbursementFormData,
  isWireDisbursementFormData,
} from 'types/order/escrow/IDisbursementFormData';
import { hasCopyableFields } from '../../utils/disbursementCopyUtils';

interface ShouldShowCopyPasteOptionsParams {
  showCopyPasteOptions: boolean;
  isReadOnly: boolean;
  data: IDisbursementFormData;
  hasCopiedData: boolean;
}

export const shouldShowCopyPasteOptions = ({
  showCopyPasteOptions,
  isReadOnly,
  data,
  hasCopiedData,
}: ShouldShowCopyPasteOptionsParams): boolean => {
  return (
    showCopyPasteOptions &&
    !isReadOnly &&
    (isCheckDisbursementFormData(data) || isWireDisbursementFormData(data)) &&
    (hasCopyableFields(data) || hasCopiedData)
  );
};
